const fmtRp = (v) => new Intl.NumberFormat('id-ID', { style:'currency', currency:'IDR', minimumFractionDigits:0 }).format(v||0);
const fmtDate = (v) => v ? new Date(v).toLocaleDateString('id-ID', { day:'2-digit', month:'long', year:'numeric' }) : '-';
const terbilang = (n) => {
  const satuan = ['','satu','dua','tiga','empat','lima','enam','tujuh','delapan','sembilan','sepuluh','sebelas'];
  const fn = (x) => {
    if (x < 12) return satuan[x];
    if (x < 20) return satuan[x-10] + ' belas';
    if (x < 100) return satuan[Math.floor(x/10)] + ' puluh' + (x%10 ? ' '+satuan[x%10] : '');
    if (x < 200) return 'seratus' + (x%100 ? ' '+fn(x%100) : '');
    if (x < 1000) return satuan[Math.floor(x/100)] + ' ratus' + (x%100 ? ' '+fn(x%100) : '');
    if (x < 2000) return 'seribu' + (x%1000 ? ' '+fn(x%1000) : '');
    if (x < 1000000) return fn(Math.floor(x/1000)) + ' ribu' + (x%1000 ? ' '+fn(x%1000) : '');
    if (x < 1000000000) return fn(Math.floor(x/1000000)) + ' juta' + (x%1000000 ? ' '+fn(x%1000000) : '');
    return fn(Math.floor(x/1000000000)) + ' miliar' + (x%1000000000 ? ' '+fn(x%1000000000) : '');
  };
  if (!n || n === 0) return 'nol rupiah';
  return fn(Math.abs(Math.floor(n))) + ' rupiah';
};

const BASE_CSS = `
  * { margin:0; padding:0; box-sizing:border-box; }
  body { font-family: Arial, sans-serif; font-size: 11px; color: #000; }
  h2 { font-size: 14px; text-align:center; margin-bottom:2px; }
  h3 { font-size: 12px; text-align:center; margin-bottom:12px; color:#555; }
  table { width:100%; border-collapse:collapse; margin-top:8px; }
  th { background:#f0f0f0; border:1px solid #999; padding:5px 7px; text-align:left; font-size:10px; }
  td { border:1px solid #ccc; padding:5px 7px; vertical-align:top; }
  .right { text-align:right; }
  .center { text-align:center; }
  .total-row td { font-weight:bold; background:#f9f9f9; }
  .header { margin-bottom:16px; }
  .header p { font-size:11px; }
  .sign { margin-top:40px; display:flex; justify-content:flex-end; }
  .sign-box { text-align:center; width:200px; }
  .sign-box .line { margin-top:50px; border-top:1px solid #000; padding-top:4px; }
  @media print { @page { margin: 1.5cm; } button { display:none; } }
`;

function openPrint(title, bodyHtml) {
  const w = window.open('', '_blank', 'width=900,height=700');
  w.document.write(`<!DOCTYPE html><html><head><meta charset="utf-8"><title>${title}</title><style>${BASE_CSS}</style></head><body>${bodyHtml}<br/><div style="text-align:center;margin-top:16px"><button onclick="window.print()" style="padding:8px 24px;font-size:12px;cursor:pointer;background:#2563EB;color:#fff;border:none;border-radius:4px;margin-right:8px">🖨 Cetak</button><button onclick="window.close()" style="padding:8px 24px;font-size:12px;cursor:pointer;background:#6B7280;color:#fff;border:none;border-radius:4px">✕ Tutup</button></div></body></html>`);
  w.document.close();
}

export function printKwitansi(data) {
  const html = `
    <div class="header" style="border-bottom:2px solid #000;padding-bottom:10px;margin-bottom:16px">
      <h2>BUKTI PENERIMAAN KAS</h2>
      <h3>Integrated Financial Management System (IFMS)</h3>
    </div>
    <table style="border:none;margin:0">
      <tr><td style="border:none;width:140px;font-weight:600">No. BKM</td><td style="border:none">: <strong>${data.no_bukti}</strong></td></tr>
      <tr><td style="border:none;font-weight:600">Tanggal</td><td style="border:none">: ${fmtDate(data.tanggal)}</td></tr>
      <tr><td style="border:none;font-weight:600">Sumber Dana</td><td style="border:none">: ${data.sumber_dana||'-'}</td></tr>
      <tr><td style="border:none;font-weight:600">Akun</td><td style="border:none">: ${data.kode_akun||''} - ${data.nama_akun||''}</td></tr>
      <tr><td style="border:none;font-weight:600">Keterangan</td><td style="border:none">: ${data.keterangan}</td></tr>
    </table>
    <div style="margin:20px 0;padding:14px;border:1.5px solid #000;border-radius:4px;text-align:center">
      <div style="font-size:10px;color:#555;margin-bottom:4px">JUMLAH DITERIMA</div>
      <div style="font-size:22px;font-weight:bold">${fmtRp(data.jumlah)}</div>
      <div style="font-size:10px;color:#555;margin-top:4px;font-style:italic">Terbilang: ${terbilang(data.jumlah)}</div>
    </div>
    <table style="border:none;margin:0">
      <tr><td style="border:none;width:140px">Nama Bank</td><td style="border:none">: ${data.nama_bank||'-'}</td></tr>
      <tr><td style="border:none">No. Rekening</td><td style="border:none">: ${data.no_rekening||'-'}</td></tr>
      <tr><td style="border:none">Dicatat Oleh</td><td style="border:none">: ${data.dibuat_oleh||'-'}</td></tr>
      <tr><td style="border:none">Status</td><td style="border:none">: ${data.status}</td></tr>
    </table>
    <div class="sign">
      <div class="sign-box">
        <p>Bendahara Penerimaan,</p>
        <div class="line">(______________________)</div>
      </div>
    </div>
  `;
  openPrint(`Kwitansi ${data.no_bukti}`, html);
}

export function printBukuPenerimaan(rows, filters) {
  const total = rows.reduce((s, r) => s + Number(r.jumlah), 0);
  const rowsHtml = rows.map((r, i) => `
    <tr>
      <td class="center">${i+1}</td>
      <td>${r.no_bukti}</td>
      <td>${fmtDate(r.tanggal)}</td>
      <td>${r.sumber_dana||'-'}</td>
      <td>${r.kode_akun||''}</td>
      <td>${r.nama_akun||''}</td>
      <td>${r.keterangan}</td>
      <td class="right">${fmtRp(r.jumlah)}</td>
      <td class="center">${r.status}</td>
    </tr>
  `).join('');

  const html = `
    <div class="header">
      <h2>BUKU PENERIMAAN</h2>
      <h3>Periode: ${filters.dari||'-'} s/d ${filters.sampai||'-'} · Tahun ${filters.tahun||''}</h3>
    </div>
    <table>
      <thead>
        <tr>
          <th class="center" style="width:30px">No</th>
          <th>No. BKM</th><th>Tanggal</th><th>Sumber Dana</th>
          <th>Kode Akun</th><th>Nama Akun</th><th>Keterangan</th>
          <th class="right">Jumlah</th><th class="center">Status</th>
        </tr>
      </thead>
      <tbody>${rowsHtml}</tbody>
      <tfoot>
        <tr class="total-row">
          <td colspan="7" class="right">TOTAL</td>
          <td class="right">${fmtRp(total)}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
    <div class="sign">
      <div class="sign-box">
        <p>Bendahara Penerimaan,</p>
        <div class="line">(______________________)</div>
      </div>
    </div>
  `;
  openPrint('Buku Penerimaan', html);
}

export function printBKU(rows, filters) {
  let saldo = 0;
  const rowsHtml = rows.map((r, i) => {
    saldo += Number(r.jumlah);
    return `
      <tr>
        <td class="center">${i+1}</td>
        <td>${r.no_bukti}</td>
        <td>${r.no_spp||'-'}</td>
        <td>${fmtDate(r.tanggal)}</td>
        <td>${r.vendor||'-'}</td>
        <td>${r.kode_akun||''}</td>
        <td>${r.nama_akun||''}</td>
        <td>${r.keterangan}</td>
        <td>${r.metode_bayar||'-'}</td>
        <td class="right">${fmtRp(r.jumlah)}</td>
        <td class="right">${fmtRp(saldo)}</td>
        <td class="center">${r.status}</td>
      </tr>
    `;
  }).join('');

  const html = `
    <div class="header">
      <h2>BUKU KAS UMUM (BKU)</h2>
      <h3>Periode: ${filters.dari||'-'} s/d ${filters.sampai||'-'} · Tahun ${filters.tahun||''}</h3>
    </div>
    <table>
      <thead>
        <tr>
          <th class="center">No</th>
          <th>No. BKK</th><th>No. SPP</th><th>Tanggal</th><th>Vendor/Penerima</th>
          <th>Kode Akun</th><th>Nama Akun</th><th>Keterangan</th>
          <th>Metode</th><th class="right">Jumlah</th><th class="right">Kumulatif</th><th class="center">Status</th>
        </tr>
      </thead>
      <tbody>${rowsHtml}</tbody>
      <tfoot>
        <tr class="total-row">
          <td colspan="9" class="right">TOTAL PENGELUARAN</td>
          <td class="right">${fmtRp(saldo)}</td>
          <td></td><td></td>
        </tr>
      </tfoot>
    </table>
    <div class="sign">
      <div class="sign-box">
        <p>Bendahara Pengeluaran,</p>
        <div class="line">(______________________)</div>
      </div>
    </div>
  `;
  openPrint('Buku Kas Umum (BKU)', html);
}
